const totalData  = function(tableData, totalArr) {
  const array = tableData
  if (!array || !array.length) return totalArr
  let totalName = Object.keys(totalArr)
  array.forEach((val, key) => {
    totalName.forEach(it => {
      totalArr[it] = Number(totalArr[it]) + Number(val[it])
    })
  })
  return totalArr
}

export default totalData